import { z } from "zod";

import { NameDescriptionItemSchema } from "./NameDescriptionItem.schema";

/**
 * Classification config — stored under `{ classification: { ... } }`.
 * _v: 1
 */
export const ClassificationPromptConfigSchema = z.object({
  _v: z.literal(1).default(1),
  categories: z.array(NameDescriptionItemSchema),
  approach: z.string(),
  possibleCategory: z.string()
});

export type ClassificationPromptConfig = z.infer<typeof ClassificationPromptConfigSchema>;
